import React from 'react'

const DotIndicator = ({fields=[], step = 1}) => {
    return (
        // <div className="dashboard-popup-teacher-profile-details-form">
            <div className="dot-indicator">
                {fields.map((field, index) => (
                    <div
                        key={field.id}
                        className={`dot ${index + 1 === step ? "active" : ""
                            }`}
                    ></div>
                ))}
            </div>
        // </div>
    )
}

export default DotIndicator